import * as yup from 'yup';

export const UpdateEnrollmentRequiredDocumentFormValidation = yup.object().shape({
    description: yup.string().required('Tipo de documento é obrigatório'),
    id: yup.string().required(),
    status: yup.bool().required()

});